export default "__VITE_ASSET__BxUAGEF4__"